import { Component, computed, inject, Input, OnInit, OnDestroy } from '@angular/core';
import {
    AvatarComponent,
    BadgeComponent,
    BreadcrumbRouterComponent,
    ColorModeService,
    ContainerComponent,
    DropdownComponent,
    DropdownDividerDirective,
    DropdownHeaderDirective,
    DropdownItemDirective,
    DropdownMenuDirective,
    DropdownToggleDirective,
    HeaderComponent,
    HeaderNavComponent,
    HeaderTogglerDirective,
    NavItemComponent,
    NavLinkDirective,
    ProgressBarDirective,
    ProgressComponent,
    SidebarToggleDirective,
    TextColorDirective,
    ThemeDirective
} from '@coreui/angular';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { Router, RouterLink, RouterLinkActive, NavigationEnd } from '@angular/router';
import { IconDirective } from '@coreui/icons-angular';
import { AuthenticationService } from '../../../services/authentication.service';
import { EllmoService } from 'src/app/services/ellmo.service';
import { CommonModule } from '@angular/common';
import { MyService } from 'src/app/services/myservice';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule, } from '@angular/forms';
import { ThemeService } from 'src/app/ellmocomponents/themeservice';
import { WebsocketService } from 'src/app/services/websocket.service';
import { CommonServices } from 'src/app/services/gz.common.services';
import { ElementRef, Renderer2 } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-default-header',
    templateUrl: './default-header.component.html',
    styleUrls: ['./default-header.component.scss'],
    standalone: true,
    imports: [CommonModule, ContainerComponent, FormsModule, ReactiveFormsModule, HeaderTogglerDirective, SidebarToggleDirective, IconDirective, HeaderNavComponent, NavItemComponent, NavLinkDirective, RouterLink, RouterLinkActive, NgTemplateOutlet, BreadcrumbRouterComponent, ThemeDirective, DropdownComponent, DropdownToggleDirective, TextColorDirective, AvatarComponent, DropdownMenuDirective, DropdownHeaderDirective, DropdownItemDirective, BadgeComponent, DropdownDividerDirective, ProgressBarDirective, ProgressComponent, NgStyle]
})
export class DefaultHeaderComponent extends HeaderComponent implements OnInit, OnDestroy {
    routerSubscription: Subscription = new Subscription();
    notifications: string[] = [];
    currentTheme = localStorage.getItem('coreui-free-angular-admin-template-theme-default');
    previousTheme: string = '';
    readonly #colorModeService = inject(ColorModeService);
    readonly colorMode = this.#colorModeService.colorMode;
    readonly colorModes = [
        { name: 'light', text: 'Light', icon: 'cilSun' },
        { name: 'dark', text: 'Dark', icon: 'cilMoon' },
    ];

    readonly icons = computed(() => {
        const currentMode = this.colorMode();
        return this.colorModes.find(mode => mode.name === currentMode)?.icon ?? 'cilSun';
    });

    dropdown: boolean = false;
    showAppFeedbackModal: boolean = false;
    // @Input() themes: any;
    appFeedbackForm!: FormGroup;
    stars: number[] = [1, 2, 3, 4, 5];
    selectedRating: number = 0;
    appFeedback: string = '';
    feedbackResponse: string = '';
    userId!: string;
    userDetails: any;
    email!: string;
    unreadNotificationsLength: number = 0;
    isDarkTheme: boolean = false;

    constructor(
        private myService: MyService,
        private authenticate: EllmoService,
        private fb: FormBuilder,
        private myserv: MyService,
        private cdr: ChangeDetectorRef,
        private authenticationService: AuthenticationService,
        private themeService: ThemeService,
        private el: ElementRef, private renderer: Renderer2,
        private websocketService: WebsocketService, public commonServices: CommonServices,
        private router: Router
    ) {
        super();
        this.#colorModeService.localStorageItemName.set('coreui-free-angular-admin-template-theme-default');
    }
    navigateToLink(url: string) {
        console.log("Navigating to URL:", url);
        this.router.navigateByUrl(url);
    }

    @Input() sidebarId: string = 'sidebar1';

    logout() {
        this.authenticationService.logout();
        localStorage.clear();
    }

    dropdownOpen: boolean = false;
    apiNotifications: any[] = [];

    selectTheme: string = '00';
    themes: boolean = false;
    ngOnInit() {
        this.routerSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.cdr.detectChanges();
                this.checkthis(); // Ensure this function updates the class
            }
        });

        this.myserv.getToken().then(token => {

            this.authenticationService.getUserProfile().then(async prof => {
                this.email = prof.email ?? '';

                this.callToGetNotifications(true);
                this.authenticate.getUserDetails(this.email, false, token).subscribe((res) => {
                    if (res) {
                        console.log('test', res.userId);
                        console.log(res);
                        this.userId = res.userId;
                        this.userDetails = res;
                        console.log("this is the theme from result", res.theme)
                        if (res.theme == '00') {
                            this.colorMode.set('dark');
                            this.isDarkTheme = true;
                        } else if (res.theme == '01') {
                            this.colorMode.set('light')
                            this.isDarkTheme = false;
                        } else {
                            this.colorMode.set('light');
                            this.isDarkTheme = false;
                        }
                    }
                });

                this.websocketService.initializeWebSocketConnection().then(() => {
                    this.websocketService.notifications.subscribe((message: string) => {
                        console.log('Received WebSocket notification:', message);
                        this.callToGetNotifications(true);
                    });
                }).catch(error => {
                    console.error('Error initializing WebSocket connection:', error);
                });

            });

        });
        document.addEventListener('click', this.handleDocumentClick);
        this.appFeedbackForm = this.fb.group({
            appFeedback: [''],
        });
    }

    ngDoCheck(): void {
        const newTheme = localStorage.getItem('coreui-free-angular-admin-template-theme-default') || 'auto';
        if (this.previousTheme !== newTheme) {
            this.currentTheme = newTheme;
            this.currentTheme = this.currentTheme.replace(/"/g, '')
            this.previousTheme = newTheme;
            console.log("this is current theme", this.currentTheme);
            this.cdr.detectChanges();
            this.checkthis();
        }
    }

    ngAfterViewInit() {
        const elements = this.el.nativeElement.querySelectorAll('.breadcrumb-item');
        console.log(elements)
        elements.forEach((element: HTMLElement) => {
            if (element.classList.contains('active')) {
                this.renderer.addClass(element, 'your-custom-class');
            }
        });


    }

    checkthis() {
        const elements = this.el.nativeElement.querySelectorAll('.breadcrumb-item');
        console.log(elements)
        elements.forEach((element: HTMLElement) => {
            if (element.classList.contains('active')) {
                this.renderer.addClass(element, 'your-custom-class');
            }
        });
    }


    handleDocumentClick = (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (this.dropdownOpen && !target.closest('.dropdown-menu') && !target.closest('[cNavLink]')) {
            this.dropdownOpen = false;
        }
    }

    ngOnDestroy() {
        document.removeEventListener('click', this.handleDocumentClick);
    }

    getUnreadNotifications() {
        return this.apiNotifications.filter(notification => notification.read_ind === 'N').slice(0, 5);
    }

    dummy(mode: any) {
        this.colorMode.set(mode.name);
        if (mode.name == 'auto') {
            this.changeTheme('light');
            this.isDarkTheme = false;
        } else {
            this.changeTheme(mode.name);
        }
    }

    toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
        this.callToGetNotifications(true);
        this.unreadNotificationsLength = 0;
    }

    changeTheme = async (theme: string) => {
        this.themeService.updateTheme(theme);
        if (theme == 'dark') {
            theme = '00'
            this.isDarkTheme = true;
        }
        else if (theme == 'light') {
            theme = '01'
            this.isDarkTheme = false;
        }
        // alert("called theme")
        this.authenticate.changeTheme(this.userId, theme, 'updateTheme', await this.myserv.getToken()).subscribe(
            (res) => {
                if (res) {
                    console.log('Theme Changed', theme);
                }
            },
            (err) => {
                console.log(err);
                alert('Received error response. while changing theme');
            }
        );
    }

    callToGetNotifications(displayAll: boolean) {
        this.myserv.getToken().then(data => {
            this.myService.getNotifications(displayAll, data).subscribe(res => {
                console.log("Received notifications:", res);
                this.apiNotifications = res.notifications;
                this.unreadNotificationsLength = this.apiNotifications.filter(notification => notification.read_ind === 'N').length;
                console.log("Unread notifications count:", this.unreadNotificationsLength);
            });
        });
    }

    removeNotification(notificationToRemove: any) {
        const notificationId = notificationToRemove.notificationId;

        this.myService.getToken().then(data => {
            this.myService.deleteNotification(notificationId, data).subscribe(
                () => {
                    console.log('Notification deleted successfully');
                    this.apiNotifications = this.apiNotifications.filter(notification => notification.notificationId !== notificationToRemove.notificationId);
                },
                error => {
                    console.error('Error deleting notification:', error);
                }
            );
        });
    }

    patchNotifications(notification: any) {
        const notificationId = notification.notificationId;
        this.myService.getToken().then(data => {
            this.myService.patchNotification(notificationId, data).subscribe(
                () => {
                    console.log('Notification read successfully');
                    const index = this.apiNotifications.findIndex(notif => notif.notificationId === notificationId);
                    if (index !== -1) {
                        this.apiNotifications[index].read_ind = 'Y';
                    }
                },
                error => {
                    console.error('Error reading notification:', error);
                });
        });
        console.log("patchNotifications Triggered" + notification.read_ind);
        console.log(JSON.stringify(notification));
    }

    updateUnreadCount() {
        this.unreadNotificationsLength = this.apiNotifications.filter(notification => notification.read_ind === 'N').length;
        console.log("Unread notifications count:", this.unreadNotificationsLength);
    }

    openFeedbackModal() {
        this.showAppFeedbackModal = true;
    }

    onStarClick(rating: number) {
        this.selectedRating = rating;
    }

    async submitAppFeedback() {
        this.authenticate.submitAppFeedback(this.userId, this.selectedRating + '', this.appFeedback, await this.myserv.getToken()).subscribe((res) => {
            console.log(res);
            this.feedbackResponse = res.message;
        });
    }

    closeAppFeedback() {
        this.showAppFeedbackModal = false;
    }
}
